(function () {
  var PROTECTED_CART_ENDPOINT = 'https://api.bureauobscura.com/api/commerce/cart';
  var protectedCartRequestSequence = 0;

  function isDark() {
    return document.documentElement.classList.contains('dark');
  }

  function persistAppearance(dark) {
    var appearance = dark ? 'dark' : 'light';
    try {
      var cookieAttributes = '; Max-Age=31536000; Path=/; SameSite=Lax';
      if (/(^|\.)bureauobscura\.com$/i.test(window.location.hostname)) {
        cookieAttributes += '; Domain=.bureauobscura.com';
      }
      if (window.location.protocol === 'https:') cookieAttributes += '; Secure';
      document.cookie = 'bo_appearance=' + appearance + cookieAttributes;
    } catch (error) {}
    try {
      localStorage.setItem('bo_appearance', appearance);
      localStorage.setItem('bo_dark_mode', dark ? '1' : '0');
    } catch (error) {}
  }

  function syncModeLabels() {
    document.querySelectorAll('[data-bo-mode-toggle]').forEach(function (button) {
      var label = isDark() ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  }

  function focusServerMessage() {
    var message = document.querySelector('[data-bo-auto-focus]');
    if (!message || !message.textContent.trim()) return;
    window.requestAnimationFrame(function () {
      message.focus();
    });
  }

  function isProtectedCartProjection(packet) {
    if (!packet || typeof packet !== 'object') return false;
    if (packet.item_count !== 1) return false;
    if (typeof packet.checkout_url !== 'string' || !packet.checkout_url) return false;
    if (typeof packet.archive_id !== 'string') return false;
    if (typeof packet.designation !== 'string') return false;
    try {
      return new URL(packet.checkout_url).protocol === 'https:';
    } catch (error) {
      return false;
    }
  }

  function projectProtectedCart() {
    var cartLink = document.querySelector('[data-bo-cart-link]');
    var cartCount = document.querySelector('[data-bo-cart-count]');
    if (!cartLink || !cartCount) return;

    var nativeItemCount = Number.parseInt(
      cartLink.getAttribute('data-bo-native-cart-count') || '',
      10,
    );
    if (!Number.isFinite(nativeItemCount) || nativeItemCount > 0) return;

    var nativeCartUrl = cartLink.getAttribute('data-bo-native-cart-url');
    cartCount.textContent = '[' + nativeItemCount + ']';
    if (nativeCartUrl) cartLink.setAttribute('href', nativeCartUrl);
    var requestSequence = ++protectedCartRequestSequence;

    fetch(PROTECTED_CART_ENDPOINT, {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (packet) {
        if (requestSequence !== protectedCartRequestSequence) return;
        if (!isProtectedCartProjection(packet)) return;
        cartCount.textContent = '[1]';
        cartLink.setAttribute('href', packet.checkout_url);
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-bo-mode-toggle]');
    if (!toggle) return;
    var dark = document.documentElement.classList.toggle('dark');
    persistAppearance(dark);
    syncModeLabels();
  });

  syncModeLabels();
  focusServerMessage();
  projectProtectedCart();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) projectProtectedCart();
  });
})();
